import { render, staticRenderFns } from "./CurrencyDeleteModal.vue?vue&type=template&id=158299a7&scoped=true&"
import script from "./CurrencyDeleteModal.vue?vue&type=script&lang=js&"
export * from "./CurrencyDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyDeleteModal.vue?vue&type=style&index=0&id=158299a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158299a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon,VSnackbar})
